<script setup lang="ts">
import type { PropType } from 'vue'
import type { ObjectsListItemMap } from '@/entities/Object'
import './assets/style.scss'
import WObjectMapinfoSelected from './WObjectMapinfoSelected.vue'
import WObjectMapInfoCabinet from './WObjectMapInfoCabinet.vue'

defineProps({
  items: {
    type: Array as PropType<ObjectsListItemMap[]>,
    default: [],
  },
})
</script>

<template>
  <div class="w-object-map-info">
    <VExpansionPanels multiple>
      <WObjectMapinfoSelected :items />

      <template v-for="item in items" :key="item.id">
        <WObjectMapInfoCabinet v-if="item.object_type_id === 1" :item />
      </template>
    </VExpansionPanels>
  </div>
</template>
